import { watch } from "vue";
import { setBackendLanguage } from "~/api/i18n";
import { useAuthStore } from "~/store/auth";

export default defineNuxtPlugin(() => {
  const { $i18n } = useNuxtApp();
  const authStore = useAuthStore();

  watch(
    () => ($i18n as any).locale.value as string,
    async (newLocale: string) => {
      if (!authStore.isAuthenticated) return;
      await setBackendLanguage(newLocale);
    },
  );
});
